import get from "lodash/get";
import {
  TRANSLATIONS_STORAGE_KEY,
  TIMESTAMP_STORAGE_KEY,
} from "../../constants";

import {
  loginRequest,
  getAppSettings,
  loginTwoFactorRequest,
  logoutRequest,
  resetPasswordRequest,
  getPermissionsRequest,
  getAccountInfoRequest,
  updateUserLanguage as updateUserLanguageRequest,
} from "../../api/requests";

export const USER_UPDATE = "USER_UPDATE";
export const USER_UPDATE_LANGUAGE = "USER_UPDATE_LANGUAGE";
export const USER_SIGN_OUT = "USER_SIGN_OUT";

export const login = ({ username, password }) => async (dispatch) => {
  try {
    const response = await loginRequest({ username, password });
    if (get(response, "data.access_token")) {
      window.localStorage.setItem("token", get(response, "data.access_token"));
      window.localStorage.setItem("language", get(response, "data.language_code"));
      setPermissions(get(response, "data.access_token"))(dispatch);
      setAccountInfo(get(response, "data.access_token"))(dispatch);
      setAppSettings(get(response, "data.access_token"))(dispatch);
    }

    return response;
  } catch (e) {
    throw new Error(get(e, "response.data.error"));
  }
};

export const setAccountInfoEnrollmentPagination = enrollmentPage => async dispatch => {
  dispatch(({ type: USER_UPDATE, payload: { enrollmentPage } }));
};

export const updateUser = (payload) => async (dispatch) => {
  dispatch({ type: USER_UPDATE, payload });
};

export const updateUserLanguage = (payload) => async (dispatch, getState) => {
  dispatch({ type: USER_UPDATE_LANGUAGE, payload: payload.id });

  await updateUserLanguageRequest({ languageId: payload.id });

  window.localStorage.setItem("language", payload.code);
  window.localStorage.removeItem(TRANSLATIONS_STORAGE_KEY);
  window.localStorage.removeItem(TIMESTAMP_STORAGE_KEY);
  window.location.reload();
};

export const loginTwoFactor = ({ username, password, code }) => async (
  dispatch
) => {
  try {
    const response = await loginTwoFactorRequest({ username, password, code });
    window.localStorage.setItem("token", get(response, "data.access_token"));
    setPermissions(get(response, "data.access_token"))(dispatch);
    setAccountInfo(get(response, "data.access_token"))(dispatch);
    setAppSettings(get(response, "data.access_token"))(dispatch);
    // dispatch(({ type: USER_UPDATE, payload: { token: get(response, 'data.access_token') } }));
    return response;
  } catch (e) {
    throw new Error(get(e, "response.data.error"));
  }
};

export const setPermissions = (token) => async (dispatch) => {
  try {
    const response = await getPermissionsRequest();
    dispatch({
      type: USER_UPDATE,
      payload: { permissions: get(response, "data") },
    });
    return token;
  } catch (e) {
    console.log(e);
    if ([401, 422].includes(get(e, "response.status"))) {
      logoutHandle(dispatch);
    }
    // throw new Error(get(e, 'response.data.error'));
  }
};

export const setAppSettings = () => async (dispatch) => {
  try {
    const response = await getAppSettings();
    dispatch({
      type: USER_UPDATE,
      payload: {
        appSettings: get(response, "data"),
      },
    });
  } catch (e) {
    console.log(e);
    if ([401, 422].includes(get(e, "response.status"))) {
      logoutHandle(dispatch);
    }
    // throw new Error(get(e, 'response.data.error'));
  }
};

export const setAccountInfo = (token) => async (dispatch) => {
  try {
    const response = await getAccountInfoRequest();
    dispatch({
      type: USER_UPDATE,
      payload: { token, info: get(response, "data") },
    });
    return token;
  } catch (e) {
    if ([401, 422].includes(get(e, "response.status"))) {
      logoutHandle(dispatch);
    }
    // throw new Error(get(e, 'response.data.error'));
  }
};

export const logoutHandle = (dispatch) => {
  window.localStorage.removeItem("token");
  window.localStorage.removeItem("language");
  window.localStorage.removeItem(TRANSLATIONS_STORAGE_KEY);
  window.localStorage.removeItem(TIMESTAMP_STORAGE_KEY);
  dispatch({ type: USER_SIGN_OUT });
};

export const logout = () => async (dispatch) => {
  try {
    await logoutRequest();
    logoutHandle(dispatch);
  } catch (e) {
    logoutHandle(dispatch);
  }
};

export const resetPassword = ({ username }) => async () =>
  resetPasswordRequest({ username });

//export const logout = () => async (dispatch, getState) => {
// console.log(getUserToken(getState()));
// try {
//   return await loginRequest({ username, password });
//   // dispatch(({ type: USER_UPDATE, payload: { token } }));
//   // return token;
// } catch (e) {
//   return e;
// }

// export const signOut = () => dispatch => dispatch(({ type: USER_SIGN_OUT }));



// WEBPACK FOOTER //
// ./src/reducers/user/actions.js